import "react-native-reanimated";
import { AnonymousWidgetPos } from "../types";
import { containsHit } from "./containsHit";
import { containsOverflowingPositions } from "./containsOverflowingPositions";

export function validPositions(
  positions: AnonymousWidgetPos[],
  numberOfColumns: number = 4,
  numberOfRows: number = 4
) {
  "worklet";
  return (
    !containsOverflowingPositions(positions, numberOfColumns, numberOfRows) &&
    !containsHit(positions)
  );
}
